import { render, staticRenderFns } from "./DraftQrCode.vue?vue&type=template&id=c6042fa2&scoped=true&"
import script from "./DraftQrCode.vue?vue&type=script&lang=js&"
export * from "./DraftQrCode.vue?vue&type=script&lang=js&"
import style0 from "./DraftQrCode.vue?vue&type=style&index=0&id=c6042fa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6042fa2",
  null
  
)

export default component.exports